import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';

import { ApiRequestDescriptor } from '../../services';

const ENDPOINT = `${APIConfiguration.document}files/${COMMON_QUERY_PARAMS.FILE_ID}/documents/status`;

export interface GetDocumentsStatusByFileRequestArgs {
  fileId: string;
}

export const getDocumentsStatusByFileRequest = ({
  fileId,
}: GetDocumentsStatusByFileRequestArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId),
  config: { method: SUPPORTED_METHODS.GET },
});
